import {ResponsivePrompt} from 'components/responsive-prompt/ResponsivePrompt';
import {useAppDispatch, useAppSelector} from 'hooks';
import {setAlertAction} from 'store/actions/alert-action';
import {AlertType} from 'store/types/app';

import {VoucherInvalidAlertContent} from './VoucherInvalidAlertContent';
import {VoucherItemDeselectedAlertContent} from './VoucherItemDeselectedAlertContent';
import {VoucherItemRemovedAlertContent} from './VoucherItemRemovedAlertContent';
import {VoucherQuantityLimitExceededAlertContent} from './VoucherQuantityLimitExceededAlertContent';

export const ResponsiveAlertPrompts = () => {
  const alertType = useAppSelector((state) => state.alert.type);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setAlertAction(undefined));
  };

  const closeChecked = () => {
    switch (alertType) {
      case AlertType.voucherExpired:
      case AlertType.voucherQuantityLimitExceeded:
        return;
    }
    return close();
  };

  return (
    <ResponsivePrompt onClose={closeChecked} open={alertType !== undefined}>
      {alertType === AlertType.voucherExpired && <VoucherInvalidAlertContent onClose={close} />}
      {alertType === AlertType.voucherQuantityLimitExceeded && (
        <VoucherQuantityLimitExceededAlertContent onClose={close} />
      )}
      {alertType === AlertType.voucherItemDeselected && <VoucherItemDeselectedAlertContent onClose={close} />}
      {alertType === AlertType.voucherItemRemoved && <VoucherItemRemovedAlertContent onClose={close} />}
    </ResponsivePrompt>
  );
};
